import * as React from "react"
import type { IconProps } from "../types"

const Plus = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="square"
          strokeWidth={2}
          d="M12 4V12M12 12V20M12 12H4M12 12H20"
        />
      </svg>
    )
  }
)
Plus.displayName = "Plus"

export default Plus
